import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

import queryString from 'query-string';

import { setLocale as initYupi18n } from 'yup';

export default (defaultNS, selectedLocale) => {
  i18n
    .use(Backend)
    .use(initReactI18next)
    .init({
      debug: true,
      load: 'languageOnly',
      lng: selectedLocale,
      fallbackLng: false,
      cleanCode: true,
      defaultNS: defaultNS,
      interpolation: {
        escapeValue: false, // not needed for react as it escapes by default
      },
      saveMissing: true,
      // react: {
      //   useSuspense: false,
      // },
    });

  i18n.on('initialized', (options) => {
    // Set translated YUP error messages
    initYupi18n({
      mixed: {
        required: ({ label }) => i18n.t('validation.mandatory', { field: label }),
      },
      string: {
        matches: ({ label }) => i18n.t('validation.string.matches', { field: label }),
        min: ({ label, min }) => i18n.t('validation.string.min', { field: label, min }),
        max: ({ label, max }) => i18n.t('validation.string.max', { field: label, max }),
      },
      number: {
        min: ({ label, min }) => i18n.t('validation.number.min', { field: label, min }),
        max: ({ label, max }) => i18n.t('validation.number.max', { field: label, max }),
        lessThan: ({ label, less }) => i18n.t('validation.number.less', { field: label, less }),
        moreThan: ({ label, more }) => i18n.t('validation.number.more', { field: label, more }),
      },
    });
  });

  return i18n;
};

const setLocale = (locale) => {
  const parsed = queryString.parse(window.location.search);
  parsed.lang = locale;
  window.location.search = queryString.stringify(parsed);
};

export { setLocale };
